<template>
    <div class="chart-block" style="padding-bottom:24px">
        <h3>   <a :href="url" target="_blank"> {{chartName}}</a>
            <el-tooltip class="item" effect="dark"  placement="bottom">
                <div v-html="tip" slot="content"></div> 
                <svg-icon name="faq" size="20" color="#53b1e7"></svg-icon>
            </el-tooltip>
            <span>{{updated}}</span>
            <el-radio-group v-model="timeType" size="mini" class="opt" @change="bindChart()" :disable="loading">
                <el-radio-button label="当月"></el-radio-button>
                <el-radio-button label="当月新能源"></el-radio-button>
                <el-radio-button label="当年"></el-radio-button>
                <el-radio-button label="当年新能源"></el-radio-button>
            </el-radio-group>
        </h3> 
        <div id="chart_province" class="chart-box" v-loading="loading">
        </div>
    </div>
</template>
<script>
    import echarts from 'echarts'
    import china from 'echarts/map/json/china.json'
    import {strToYeayAndMonth } from '@/plugins/DateTimeFormater.js';
    import {
        mapMutations,
        mapGetters,
        mapActions,
        mapState
    } from "vuex";
    export default {
        props: {
            chartName: {
                type: String,
                default: '整体市场分省份销量分布(上险数)'
            }
        },
        data() {
            return {
                url:"#",
                loading:true,
                tip:'数据来源：上险数',
                chartId: "province_chart",
                chartOption: {},
                dataList: [],
                updated: '每月中旬更新',
                timeType: '当月',
                myChart: null,
                currentDate:''

            }
        },
        mounted() {
            echarts.registerMap('china', china);
         
            this.chartOption = {
                tooltip: {
                    formatter: function(params, ticket, callback) {
                        return params.name + '<br /> 销量：' + params.value + ' 辆'
                    }
                },
                visualMap: {
                    min: 0,
                    max: 60000,
                    left: '6%',
                    top: 'bottom',
                    text: ['高', '低'],
                    inRange: {
                        color: ['#d6e8f2', '#476a9d']
                    },
                    show: false
                },
                geo: {
                    map: 'china',
                    roam: false,
                    zoom: 1.23,
                    label: {
                        normal: {
                            show: false,
                            fontSize: '10',
                            color: 'rgba(0,0,0,0.7)'
                        }
                    },
                    itemStyle: {
                        normal: {
                            borderColor: 'rgba(255, 255, 255, 0.5)'
                        },
                        emphasis: {
                            areaColor: '#F3B329',
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            shadowBlur: 20,
                            borderWidth: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                },
                series: {
                    name: '信息量',
                    type: 'map',
                    geoIndex: 0,
                    data: []
                }
            };
      
            //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
            this.getChartList({
                handle: this.updateChart
            });
        },
        methods: {
             ...mapActions("home", ["queryChartConfigs", "queryChartUpdate", "getChartList"]),
            updateChart() {
        
                this.myChart = echarts.init(document.getElementById('chart_province'));
                this.myChart.setOption(this.chartOption);
                window.addEventListener('resize', () => {
                    this.myChart.resize()
                });
                var info = this.getChartByName(this.chartId);
                 this.url = info.url;
                 this.dataList = eval("("+info.jsonData+")") ;
                // this.currentDate = this.dateList.date;
                this.updated = `最新数据时间 ${strToYeayAndMonth(this.dataList.date)}`;
                this.loading = false;
                this.bindChart();
            },
            bindChart(){
            
                 if (this.timeType == '当月') {
                    this.chartOption.series.data = this.dataList.monthly;
                } else if (this.timeType == '当月新能源') {
                  
                    this.chartOption.series.data = this.dataList.monthly_ne;
                } else if (this.timeType == '当年') {
                    this.chartOption.series.data = this.dataList.yearly;
                } else if (this.timeType == '当年新能源') {
                    this.chartOption.series.data = this.dataList.yearly_ne;
                }
           
                  this.myChart.setOption(this.chartOption);
                  
            } 

         
        },
               computed: {
            ...mapGetters("home", {
                chartList: "chartList",
                getChartByName: "getChartByName"
            }),
               },
        watch: {},
        created() {}
    }
</script>
<style scoped>
    #chart_province {
        min-height: 300px;
        min-width: 300px;
    }
</style>